import { useEffect, useRef } from "react";

export function notifyInboxChanged() {
  window.dispatchEvent(new Event("support:notifications-changed"));
}

export function useNotificationRefresh(refresh: () => Promise<unknown>) {
  const latest = useRef(refresh);
  latest.current = refresh;
  useEffect(() => {
    const update = () => { if (document.visibilityState === "visible" && navigator.onLine) void latest.current(); };
    const timer = window.setInterval(update, 30_000);
    document.addEventListener("visibilitychange", update);
    window.addEventListener("focus", update);
    window.addEventListener("online", update);
    window.addEventListener("support:notifications-changed", update);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", update);
      window.removeEventListener("focus", update);
      window.removeEventListener("online", update);
      window.removeEventListener("support:notifications-changed", update);
    };
  }, []);
}
